<template>
  <div :class="classes">
    <m4-label class="preview__label">
      <m4-icon v-if="title && withIcon" icon="file-alt"></m4-icon>
      {{ title }}
    </m4-label>
    <div class="preview__value" v-if="value">{{ value }}</div>
    <div class="preview__value" v-if="hasSlot"><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: "M4Preview",
  props: {
    title: String,
    value: String,
    borderBottom: Boolean,
    withIcon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasSlot() {
      return typeof this.$slots.default === "function";
    },
    classes() {
      let classes = ["preview"];
      if (this.borderBottom) {
        classes.push("preview--border-bottom");
      }
      if (this.withIcon) {
        classes.push("preview--with-icon");
      }
      return classes;
    }
  }
};
</script>
